import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IMAGES } from "../../../../../assets/images";
import SignUp from "../../component/sign-up";
import SignIn from "../../component/sign-in";
import { routerPath } from "../../../../navigation/path";
import { useDispatch } from "react-redux";
import { setToken, setUser } from "../../../../../store/slices/userSlice";
import Mobile from "../../component/mobile";
import OTP from "../../component/otp";
import ForgotPassword from "../../component/forgot-password";
import { changePassword, loginUser, registerUser, sendOtp, verifyOtp } from "../../services";
import { toast } from "react-toastify";
import ImageSlider from "../../../../components/ImageSwiper/ImageSlider";

const Login = () => {
    const [currentPage, setCorrentPage] = useState('signIn');
    const [isLoader, setLoader] = useState(false);
    const [pageProps, setPageProps] = useState({});

    const navigate = useNavigate()
    const dispatch = useDispatch()



    const pageUpdated = (page) => {
        setCorrentPage(page);
    };


    const signInSubmit = async (value) => {
        console.log(value);
        let payload = {
            mobile_number: '',
            email: value.email,
            password: value.password,
            is_otp: 0,
            otp: ''
        }
        setLoader(true);
        try {
            const res = await loginUser(payload)
            setLoader(false);
            toast.success(res.message)
            dispatch(setUser({ ...res.data.user, token: res.data.token }))
            localStorage.setItem('user', JSON.stringify({ ...res.data.user, token: res.data.token }))
            // dispatch(setToken({ token: res.data.token }))
            if (res.data.user.is_membership == 1) {
                localStorage.setItem('token', JSON.stringify(res.data.token))
                dispatch(setToken({ token: res.data.token }))
                navigate(routerPath.home);
            } else {
                navigate(routerPath.purchasePlan);
            }
        } catch (err) {
            console.log(err)
            setLoader(false);
        }
    };

    const signUpSubmit = async (value) => {
        let payload = {
            name: value.fullName,
            email: value.email,
            mobile_number: value.phoneNumber,
            password: value.password
        }
        console.log("signUpSubmit", payload);
        try {
            setLoader(true);
            const res = await registerUser(payload)
            toast.success(res.message)
            setPageProps({ ...payload, action: 'register' })
            console.log(res)
            setLoader(false);
            setCorrentPage('otp')
        } catch (err) {
            console.log(err)
            setLoader(false);
            toast.error(err)
        }
    };

    const mobileSubmit = async (value) => {
        console.log("mobileSubmit", value);
        let parma = {
            mobile_number: value.phoneNumber,
            action: 'login',
            password: '',
            is_otp: 1,
        }
        try {
            setLoader(true);
            const res = await sendOtp({ mobile_number: value.phoneNumber })
            setLoader(false);
            toast.success(res.message)
            setPageProps(parma)
            setCorrentPage('otp')
        } catch (err) {
            setLoader(false);
            toast.success(err)
        }

    };

    const otpSubmit = async (value) => {
        try {
            setLoader(true);
            let res = {}
            if (value.action == 'login') {
                res = await loginUser(value)
            } else if (value.action == 'register') {
                res = await verifyOtp(value)
            } else {
                res = await changePassword(value)
            }
            console.log(res)
            setLoader(false);
            toast.success(res.message)
            if (value.action == 'forgot') {
                setCorrentPage('signIn')
            } else {
                dispatch(setUser({ ...res.data.user, token: res.data.token }))
                localStorage.setItem('user', JSON.stringify({ ...res.data.user, token: res.data.token }))
                if (res.data.user.is_membership == 1) {
                    localStorage.setItem('token', JSON.stringify(res.data.token))
                    dispatch(setToken({ token: res.data.token }))
                } else {
                    navigate(routerPath.purchasePlan);
                }
            }
        } catch (err) {
            setLoader(false);
            console.log(err)
        }
    };

    const forgotpasswordSubmit = async (value) => {
        try {
            setLoader(true);
            const res = await sendOtp({ mobile_number: value.phoneNumber })
            setLoader(false);
            toast.success(res.message)
            setPageProps({ ...value, mobile_number: value.phoneNumber, action: 'forgot' })
            setCorrentPage('otp')
        } catch (err) {
            setLoader(false);

        }

    };

    const cards = [
        { id: 1, title: "Health Coaching", icon_img: IMAGES.healthCoaching },
        { id: 2, title: "Health Assesment", icon_img: IMAGES.healthAssesment },
        { id: 3, title: "Nutrition Counselling", icon_img: IMAGES.nutritionCounselling },
        { id: 4, title: "Fitness Program", icon_img: IMAGES.fitnessProgram },
        { id: 5, title: "Mental Health Support", icon_img: IMAGES.mentalHealthSupport },
        { id: 6, title: "Stress Management", icon_img: IMAGES.stressManagement },
    ]

    const [SelectorIndex, setSelectorIndex] = useState(0)
    const swiperRef = useRef(null)
    useEffect(() => {
        const interval = setInterval(() => {
            setSelectorIndex((prevIndex) => (prevIndex + 1) % cards.length);
            if (swiperRef.current) {
                swiperRef.current.slideTo((SelectorIndex + 1) % cards.length);
            }
        }, 2000)
        return () => clearInterval(interval)
    }, [SelectorIndex])


    return (
        <div className="h-screen w-screen">
            <div className="grid grid-cols-1 md:grid-cols-2 h-full w-full">
                {/* Left Side */}
                <div className="h-full relative overflow-y-auto flex flex-col justify-between"
                    style={{
                        background: `
                          linear-gradient(to right, rgb(0, 0, 43), rgb(0, 0, 43)), 
                          radial-gradient(circle at top left, rgba(25, 58, 130, 0.16), transparent 50%),
                          radial-gradient(circle at bottom right, rgba(25, 58, 130, 0.16), transparent 50%)`,
                        backgroundBlendMode: 'overlay',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none'
                    }}>
                    <img className="mt-9 mb-6 mx-auto h-[95px] w-[108px]" src={IMAGES.loginLogo} alt="" />
                    <div className="w-[80%] mx-auto">
                        <ImageSlider swiperRef={swiperRef} />
                    </div>
                    <div className="w-[80%] mx-auto flex flex-row gap-4 flex-wrap justify-between pb-4 origin-center">
                        {cards.map((card, index) => (
                            <div key={card.id} className={`w-[45%] h-[74px] rounded-xl flex items-center px-3 py-2 gap-3 shadow-lg transition-all duration-500 ease-in-out`}
                                style={{
                                    border: index == SelectorIndex ? '2px solid rgba(33, 67, 143, 0.38)' : '1px solid #21438f61',
                                    // borderRight: index == SelectorIndex && '0px',
                                    background: index == SelectorIndex
                                        ? 'linear-gradient(to right, rgb(0, 0, 153), rgba(25, 58, 130, 0.16) 63%)'
                                        : 'linear-gradient(to right , rgb(0, 0, 43), rgba(25, 58, 130, 0.16))',
                                    transition: 'all 0.5s ease-in-out',
                                    transform: index === SelectorIndex ? 'scale(1.05)' : 'scale(1)',
                                    willChange: 'transform',
                                    transformOrigin: 'center'
                                }}
                            >
                                <div className="w-12 h-12 flex items-center justify-center rounded-lg overflow-hidden">
                                    <img src={card.icon_img} alt="" className="" />
                                </div>
                                <div className="text-white text-md font-semibold leading-tight">
                                    {card.title}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="bg-white w-full flex justify-around flex-wrap py-2 mt-4">
                        <img className="" src={IMAGES.healthians} alt="" />
                        <img className="" src={IMAGES.apolloPharmacy} alt="" />
                        <img className="" src={IMAGES.netmeds} alt="" />
                        <img className="" src={IMAGES.qua} alt="" />
                        <img className="" src={IMAGES.apollo} alt="" />
                        <img className="" src={IMAGES.kapiva} alt="" />
                    </div>
                </div>
                {/* <div className="h-full relative overflow-y-auto flex flex-col justify-between">
                    <Lottie animationData={animationData} loop={true} autoPlay />
                </div> */}
                {/* Right Side */}
                <div className="p-8 flex flex-col justify-center bg-white h-full">
                    {
                        currentPage === 'signIn' ?
                            <SignIn onPageUpdate={pageUpdated} onFormSubmit={signInSubmit} isLoader={isLoader} />
                            : currentPage === 'signUp' ?
                                <SignUp onPageUpdate={pageUpdated} onFormSubmit={signUpSubmit} isLoader={isLoader} />
                                : currentPage === 'mobile' ?
                                    <Mobile onPageUpdate={pageUpdated} onFormSubmit={mobileSubmit} isLoader={isLoader} />
                                    : currentPage === 'otp' ?
                                        <OTP onPageUpdate={pageUpdated} pageProps={pageProps} onFormSubmit={otpSubmit} isLoader={isLoader} />
                                        :
                                        <ForgotPassword onPageUpdate={pageUpdated} onFormSubmit={forgotpasswordSubmit} isLoader={isLoader} />
                    }
                </div>
            </div>
        </div>
    );
};

export default Login;
